module.exports = __webpack_public_path__ + "img/queue.215c96f7.jpg";